import StoreSelectTable from "./StoreSelectTable";
export default StoreSelectTable;
